import { url } from "./misc";
import Cookies from 'js-cookie';

export async function SendVerificationCode(operation) {
    const endpoint = url + "/api/verify/send";
    console.log(endpoint)
    const JWT = Cookies.get('CF_Authorization');

    // Create the request options
    const requestOptions = {
        method: 'POST',
        headers: {
            'JWT': JWT,

        },
        body: operation,
    };


    // Make the HTTP request
    const response = await fetch(endpoint, requestOptions);
    return response

}

export async function VerifyCode(key, code) {
    console.log(key)
    console.log(code)
    const JWT = Cookies.get('CF_Authorization');

    const endpoint = url + "/api/verify/code";
    // Define the request parameters
    const requestData = {};

    // Create the request options
    const requestOptions = {
        method: 'POST',
        headers: {
            'JWT': JWT,
            'key': key,
            'code': code
        },
        body: JSON.stringify(requestData),
    };


    // Make the HTTP request
    const response = await fetch(endpoint, requestOptions);
    return response;

}